export const ERROR_MESSAGE = 'Something went wrong. Please try again later.';

export const DOCUMENT_CHECK_ERROR_MESSAGES = {
  NO_ERRORS: 'No errors were detected',
  LANGUAGE:
    'Language translated from may not match the document uploaded. Please review before submission.',
  DOCUMENT_TYPE:
    'Document type may not match the document uploaded. Please review before submission.',
  QUALITY:
    'The uploaded document may be unclear, cropped, or photographed from a screen. Please review before submission.',
  FAILED:
    'Document check failed. Please update the file and try again, or use the checkbox below to proceed.',
  SOMETHING_WENT_WRONG:
    'Something went wrong while preparing your document for checking. Please try again later.',
  TIMEOUT: 'Document check times out. Please try again.',
  CONFIRM_CHECK: 'You must accept the terms',
};

export const CONFIRM_DOCUMENT_CHECK_REVIEW =
  'I confirm I have reviewed all warnings and that the information provided is accurate';

export const DISCLAIMER_MESSAGE = {
  PRIVACY_LINK: 'https://www.tisnational.gov.au/Policies/Privacy-Notice',
  TERMS_CONDITIONS_LINK:
    'https://www.tisnational.gov.au/en/Our-services/Free-Translating-Service/Terms-and-Conditions',
  PRIVACY_TEXT: 'TIS National Privacy Notice',
  TERMS_CONDITIONS_TEXT:
    'Free Translating Service User Agreement Terms and Conditions',
  DOCUMENT_TRANSLATIONS_PURPOSE_CONFIRMATION_LABEL:
    'I confirm that the document translations are required to further education, employment, or community engagement in Australia.',
  DOCUMENT_TRANSLATIONS_PURPOSE_CONFIRMATION_DESCRIPTION:
    'The document translations are not for VISA application purposes. I declare the information provided is true and correct, and any misinformation may result in the refusal of this application.',
  DOCUMENT_UPLOAD_ON_BEHALF_LABEL:
    "I confirm that I am uploading another person's document(s) and I have the necessary authority to provide the document(s) on their behalf",
};
